export default __webpack_public_path__ + "static/media/SRR_white_text_logo.b3faa685.png";